module.exports = __webpack_public_path__ + "img/functions_hover.ee9d28d6.svg";